import { Modal, ModalBody, ModalHeader } from "reactstrap";
import SpinnerWheel from "../SpinnerWheel/SpinnerWheel";
import dcgLogo from "../../assets/img/brand/dcg_logo_header.png"
export default function ProcessingPaymentModal() {
    const spinnerInterval = 10000;
    return (
        <div>
            <Modal isOpen={true} centered={true} fullscreen="xl">
                <ModalHeader style={{display: 'unset'} }><div style={{ textAlign: "center" }}><img src={dcgLogo} alt="dcg logo" /></div></ModalHeader>
                <ModalBody className="mx-auto">
                    <SpinnerWheel interval={spinnerInterval} />
                    <p className="text-center">We are Processing your changes.</p>
                    <p className="text-center small">Please do not leave or close this page</p>
                </ModalBody>
            </Modal>
        </div>
    );
}